// extracted by mini-css-extract-plugin
export default {"root":"qxo1a6cl"};